type getBarBackColorParams = {
  hideCustomColors: boolean
  tags?: string[]
  tagsById: MStore.RootState['resources']['tagsById']
  position: MData.Position
  defaultColor: string
}

const getBarBackColor = ({ hideCustomColors, tags, position, defaultColor, tagsById }: getBarBackColorParams) => {
  if (hideCustomColors) return null

  if (tags && tags.length > 0) {
    const [tagColor] = tags
      .map(tagId => {
        return tagsById[tagId]?.color
      })
      .filter(color => Boolean(color) && color !== defaultColor)

    if (tagColor) {
      return tagColor
    }
  }

  const positionColor = position?.color

  if (positionColor && positionColor !== defaultColor) {
    return positionColor
  }

  return null
}

export { getBarBackColor }
